import Vue from 'vue';
import Vuex from 'vuex';
import API from '@/services/GraphQl';
import { Collections } from '@/store/Collections';
import { SiteConfiguration } from '@/store/SiteConfiguration';
Vue.use(Vuex);
export default new Vuex.Store({
  state: {
    users: [],
    isLoadedUsersList: false,
    userGroups: null,
    mode: window.location.origin.includes('stage')
      ? 'stage' : 'dev',
    userInfo: null,
    showInviteUserModal: false,
    isReinviteModalOpened: false,
    showLibraryEditingModal: false,
    showUserGroupsgModal: false,
    openedDetailUserId: null,
    libraryLinks: null,
    showSpinner: false,
    detailProjectData: null,
    nextToken: null,
    loginRelatedPages: [
      'login',
      'sign-up',
      'confirm-sign-up',
      'reset-password',
      'confirm-reset-password',
      'complete-new-password',
      'get-file',
    ],
    snackbar: {
      isSnackBarShown: false,
      title: null,
      text: null,
      pdfLink: null,
    },
  },
  mutations: {
    setIsLoadedUsersList(state, payload) {
      state.isLoadedUsersList = payload;
    },
    changeOpenedDetailForUser(state, payload) {
      state.openedDetailUserId = payload;
    },
    changeUserGroups(state, payload) {
      state.userGroups = payload;
    },
    changeUserList(state, payload) {
      state.users = payload;
    },
    changeNextToken(state, payload) {
      state.nextToken = payload;
    },
    changeLibraryLinks(state, payload) {
      state.libraryLinks = payload;
    },
    openLinkInNewWindow(state, link) {
      window.open(link, '', 'height=600, width=600, scrollbars=auto');
    },
    setUserInfo(state, data) {
      state.userInfo = data;
    },
    spinner(state, show) {
      state.showSpinner = show;
    },
    setDetailDataOfProject(state, data) {
      state.detailProjectData = data;
    },
    showModalAction(state, criteria) {
      state[criteria] = !state[criteria];
    },
    openSnackBar(state, { title, text, pdfLink }) {
      state.snackbar.isSnackBarShown = true;
      state.snackbar.title = title;
      state.snackbar.text = text;
      state.snackbar.pdfLink = pdfLink;
    },
  },
  actions: {
    handleError({ commit }, error) {
      let text;
      if (typeof error === 'string') {
        text = error;
      } else {
        const err = error.errors && error.errors[0]?.message;
        text = err ? err : 'Something went wrong';
      }
      commit('openSnackBar', {
        text,
      });
    },
    async changeUserGroups({ commit, state }, { groupsToAdd, groupsToRemove, removeFromList }) {
      commit('spinner', true);
      try {
        const { data } = await API.changeUserGroups({
          userId: state.openedDetailUserId,
          groupsToAdd,
          groupsToRemove,
        });
        const { response } = data;
        if (removeFromList) {
          const findUserIndex = state.users.findIndex(user => user.email === response.email);
          state.users.splice(findUserIndex, 1);
        }
        commit('showModalAction', 'showUserGroupsgModal');
      } catch (err) {
        console.log(err);
      } finally {
        commit('spinner', false);
      }
    },
    async getUserGroups({ commit, state }) {
      commit('spinner', true);
      try {
        const { data } = await API.getUserGroups({
          userId: state.openedDetailUserId,
        });
        const { response } = data;
        commit('changeUserGroups', response);
      } catch (err) {
        console.log(err);
      } finally {
        commit('spinner', false);
      }
    },
    async searchUsers({ commit }, searchString) {
      commit('spinner', true);
      try {
        const { data } = await API.searchUsers({
          searchString,
        });
        const { users } = data;
        commit('changeUserList', users);
        commit('changeNextToken', null);
      } catch (err) {
        commit('changeUserList', []);
        commit('changeNextToken', null);
        console.log(err);
      } finally {
        commit('spinner', false);
      }
    },
    async getAllUsers({ commit, state, dispatch }, { ascending, limit = 500 }) {
      try {
        const { data } = await API.getAllUsers({
          group: null,
          ascending,
          nextToken: state.nextToken,
          limit,
        });
        const { nextToken, users } = data.response;
        // Append new users to existing list
        commit('changeUserList', [...state.users, ...users]);
        commit('changeNextToken', nextToken);
        // Continue loading if there are more users
        if (nextToken) {
          // Use setTimeout to prevent blocking the UI
          setTimeout(() => {
            dispatch('getAllUsers', {
              ascending, limit,
            });
          }, 100);
        } else {
          // All users loaded, set loading complete
          commit('setIsLoadedUsersList', true);
        }
      } catch (err) {
        console.log('Error loading all users:', err);
        commit('setIsLoadedUsersList', true);
      }
    },
    async getAdminLibraryLinks({ commit, state }) {
      commit('spinner', true);
      try {
        const response = await API.getAdminLibraryLinks({
          userId: state.openedDetailUserId,
        });
        commit('changeLibraryLinks', response.data.response);
      } catch (err) {
        console.log(err);
      } finally {
        commit('spinner', false);
      }
    },
    async updateAdminLibraryLinks({ commit, state }, data) {
      commit('spinner', true);
      try {
        const response = await API.updateAdminLibraryLinks({
          ...data,
          userId: state.openedDetailUserId,
        });
        commit('changeLibraryLinks', response.data.response);
        commit('showModalAction', 'showLibraryEditingModal');
      } catch (err) {
        console.log(err);
      } finally {
        commit('spinner', false);
      }
    },
  },
  modules: {
    Collections,
    SiteConfiguration,
  },
});
